import axios from 'axios'
import createAuthRefreshInterceptor from 'axios-auth-refresh'
import { load } from 'recaptcha-v3'
import store from '../store/store'
import { AuthMissingError } from '@/utils/errors'
import { getPersistentAuth } from '@/utils/firebase'

const axiosInstance = axios.create({
  baseURL: process.env.API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

function endpointFromUrl (url) {
  const fragments = url.split('?')[0].split('/')
  return fragments[fragments.length - 1] || fragments[fragments.length - 2]
}

axiosInstance.interceptors.request.use(
  async (config) => {
    const recaptcha = await load(process.env.RECAPTCHA)
    const action = endpointFromUrl(config.url)
    const token = await recaptcha.execute(action)
    config.headers['X-Recaptcha'] = token
    return config
  }
)

const refreshAuth = async failedRequest => {
  console.log('Failed request handler ', failedRequest)
  try {
    await store.dispatch('auth/refreshToken')
    if (store.state.auth.refreshToken !== null) {
      failedRequest.response.config.headers.Authorization = `Bearer ${store.state.auth.accessToken}`
    }
  } catch (error) {
    error.request = failedRequest
    store.commit('auth/setRefreshToken', null)
    throw new AuthMissingError('Not logged in')
  }
}

createAuthRefreshInterceptor(axiosInstance, refreshAuth, { statusCodes: [401, 403] })

axiosInstance.interceptors.request.use(async request => {
  console.log('Adding auth to request')
  let token = null
  if (request.url !== '/users/login_link/') {
    if (store.state.auth.refreshToken && store.state.auth.accessToken === null) {
      await store.dispatch('auth/refreshToken')
    }
    if (store.state.auth.accessToken) {
      console.log('Using access token')
      token = store.state.auth.accessToken
    } else {
      const auth = await getPersistentAuth()
      if (auth.currentUser) {
        console.log("Using firebase's access token")
        token = await auth.currentUser.getIdToken()
      } else {
        console.log('User not logged in with Firebase')
      }
    }
    if (!token) {
      throw new AuthMissingError('Not logged in')
    }
    request.headers.Authorization = `Bearer ${token}`

    return request
  }
  return request
})

export { axiosInstance }
